function modalDrag(element) {
  let elementX = 0;
  let elementY = 0;
 
  //Obtener el elemento padre
  const parentElement = element.offsetParent;
  //Obtener la posicion top del elemento padre
  const parentTopPosition = parentElement?.style.top || 0;

  // const topTarget = parseInt(window.innerHeight) - element.clientHeight;
  // if (topTarget > 0) {
  //   elementY = window.scrollY + topTarget / 5;
  // } else {
  //   elementY = window.scrollY + 50;
  // }

  //al scroll que se hizo en la ventana, añadirle 100 px y restarle la posicion top del elemento padre
  elementY = window.scrollY + 100 - parseInt(parentTopPosition, 10);
  
  element.style.top = `${elementY}px`;

  /*** Makes an element draggable.
   *
   * @param {HTMLElement} element - The element.
   */
  function draggable(element) {
    let isMouseDown = false;

    // initial mouse X and Y for `mousedown`
    let mouseX;
    let mouseY;

    // element X and Y before and after move

    // mouse button down over the element
    element.firstChild.addEventListener("mousedown", onMouseDown);

    /**
     * Listens to `mousedown` event.
     *
     * @param {Object} event - The event.
     */
    function onMouseDown(event) {
      mouseX = event.clientX;
      mouseY = event.clientY;
      isMouseDown = true;
    }

    // mouse button released
    element.firstChild.addEventListener("mouseup", onMouseUp);

    /**
     * Listens to `mouseup` event.
     *
     * @param {Object} event - The event.
     */
    function onMouseUp(event) {
      isMouseDown = false;
      elementX = parseInt(element.style.left) || 0;
      elementY = parseInt(element.style.top) || 0;
    }

    // need to attach to the entire document
    // in order to take full width and height
    // this ensures the element keeps up with the mouse
    document.addEventListener("mousemove", onMouseMove);

    /**
     * Listens to `mousemove` event.
     *
     * @param {Object} event - The event.
     */
    function onMouseMove(event) {
      if (!isMouseDown) return;
      let deltaX = event.clientX - mouseX;
      let deltaY = event.clientY - mouseY;
      element.style.left = elementX + deltaX + "px";
      element.style.top = elementY + deltaY + "px";
    }
  }

  draggable(element);
}

export default modalDrag;